import { ResponseErrorCode } from '../enums/responseErrorCode';

export const translationKeys: { [key in ResponseErrorCode]: string } = {
  [ResponseErrorCode.AUTO_FUNNEL_PAYMENT_NO_POSTAL_CODE]:
    'ModSqueezePageLPCFunnelOrderFormPaymentGrowlerNoPostalCodeError',
  [ResponseErrorCode.PAYPAL_NO_BUTTONS]: 'ModSqueezePageLPCCreatePagePayPalNoButtons',
};
